import { login, logout, getProfile, setPresence as setPresenceRequest } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import { processImageFields } from '@/utils/image'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    userInfo: {}
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USER_INFO: (state, userInfo) => {
    // 处理用户信息中的图片字段
    const processedUserInfo = processImageFields(userInfo, ['avatar'])
    state.userInfo = processedUserInfo
    // 同时更新 name 和 avatar 字段
    if (processedUserInfo.nickname) {
      state.name = processedUserInfo.nickname
    }
    if (processedUserInfo.avatar) {
      state.avatar = processedUserInfo.avatar
    }
  },
  MERGE_USER_INFO: (state, partial) => {
    state.userInfo = { ...state.userInfo, ...partial }
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getProfile().then(response => {
        const { data } = response

        if (!data) {
          return reject('获取用户信息失败，请重新登录')
        }

        // 提交用户信息到 store
        commit('SET_USER_INFO', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },

  // set token
  setToken({ commit }, token) {
    return new Promise(resolve => {
      commit('SET_TOKEN', token)
      setToken(token)
      resolve()
    })
  },

  setPresenceStatus({ commit }, presence_status) {
    return setPresenceRequest({ presence_status }).then(response => {
      if (response && response.code === 1) {
        commit('MERGE_USER_INFO', { presence_status })
      }
      return response
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

